import { define } from "../preactement/define";
import { TooltipIcon } from "../../Tooltip";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['inversed'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    inversed,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(TooltipIcon, {
    ...otherProps,
    inversed: parseBooleanAttr(inversed)
  });
};
define('ds-tooltip-icon', () => Wrapper, {
  attributes
});